import { defineMessages } from 'react-intl'

export default defineMessages({
  'youMustFillInAllRequiredFields': {
    id: 'contactUs.youMustFillInAllRequiredFields',
    defaultMessage: 'You must fill in all required fields.',
  },
  'contactUs': {
    id: 'contactUs.contactUs',
    defaultMessage: 'Contact Us',
  },
  'name': {
    id: 'contactUs.name',
    defaultMessage: 'Name*',
  },
  'email': {
    id: 'contactUs.email',
    defaultMessage: 'Email*',
  },
  'subject': {
    id: 'contactUs.subject',
    defaultMessage: 'Subject*',
  },
  'message': {
    id: 'contactUs.message',
    defaultMessage: 'Message',
  },
  'submitForm': {
    id: 'contactUs.submitForm',
    defaultMessage: 'Submit Form',
  },
  'successMessage': {
    id: 'contactUs.successMessage',
    defaultMessage: `Thank you {name} for using our contact form! Your email was successfully sent!`,
  },
})
